import React from 'react';

/**
 * Componente que exibe um indicador de carregamento simples
 * @param {Object} props - Propriedades do componente
 * @param {string} props.size - Tamanho do indicador ('sm', 'md', 'lg')
 * @param {string} props.color - Cor do indicador (pode ser uma cor hexadecimal ou uma classe Tailwind)
 * @param {string} props.message - Mensagem opcional a ser exibida abaixo do indicador
 */
const LoadingIndicator = ({ 
  size = 'md', 
  color = '#4F46E5', 
  message = 'Carregando...' 
}) => {
  // Mapear tamanhos para classes CSS
  const sizeMap = {
    sm: 'h-6 w-6 border-2',
    md: 'h-8 w-8 border-3',
    lg: 'h-12 w-12 border-4'
  };
  
  const sizeClass = sizeMap[size] || sizeMap.md;
  
  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div 
        className={`animate-spin rounded-full ${sizeClass} border-solid border-r-transparent mb-2`}
        style={{ borderColor: `${color} transparent ${color} ${color}` }}
      />
      {message && (
        <p className="text-gray-600">{message}</p>
      )}
    </div>
  );
};

export default LoadingIndicator; 